<template>
  <div>
    <div class="com-banner" style="background-image:url(https://fs.58keeper.com/contact-bg.jpg)">
      <div class="banner-inner center">
        <h1>联系托管</h1>
        <p>专注房屋管理，免费养护，长短租经营，创造价值</p>
      </div>
    </div>
    <div class="section contact-section">
      <div class="com-container">
        <div class="t-center">
          <h2>请填写您家的基础信息</h2>
          <p>我们会尽快给您致电<br>
            如果你有任何问题或担心，请让我们知道<br>
            我们始终在努力<br>
            能服务到您，我们倍感荣幸
          </p>
          <p class="mt-30"><a href="tel:18621703105">石经理：18621703105</a></p>
          <p><a href="mailto:shiguodong@58keeper.com">shiguodong@58keeper.com</a></p>
        </div>
        <form class="my-form" action="##">
          <div class="row">
            <div class="col-md-6">
              <label>姓名</label>
              <input type="text" name="name" v-model="user.name" class="my-input" maxlength="5">
            </div>
            <div class="col-md-6">
              <label>电话</label>
              <input type="number" name="mobile" v-model="user.mobile" class="my-input" maxlength="11">
            </div>
            <div class="col-md-12">
              <label>房屋信息</label>
              <input type="text" name="remark" v-model="user.remark" class="my-input" maxlength="200">
            </div>
          </div>
          <button type="button" class="submitBtn" @click="submit">立即了解更多</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
let _self
export default {
  name: 'contact',
  data: function () {
    return {
      user: {
        name: '',
        mobile: '',
        remark: ''
      }
    }
  },
  methods: {
    submit () {
      if (!_self.user.name.trim()) {
        alert('请填写姓名')
        return
      }
      if (!_self.user.mobile.trim() || _self.user.mobile.trim().length != 11) {
        alert('请填写正确手机号')
        return
      }
      if (!_self.user.remark.trim()) {
        alert('请填写房源信息')
        return
      }
      _self.$http.post('/api/trusteeship/input', _self.user).then(function (res) {
        _self.$router.push({
          path: '/result',
          query: {
            msg: res.data
          }
        })
      }).catch(function (res) {
          alert('提交失败，请拨打电话')
      })
    }
  },
  mounted () {
    _self = this
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue